/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Deal_Splits_Share_PreviewInputs */

const cs_deal_splits_share_preview = /** @type {(inputs: Deal_Splits_Share_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podíl ≈ ${i?.amount}`)
};

const en_deal_splits_share_preview = /** @type {(inputs: Deal_Splits_Share_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share ≈ ${i?.amount}`)
};

/**
* | output |
* | --- |
* | "Share ≈ {amount}" |
*
* @param {Deal_Splits_Share_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_share_preview = /** @type {((inputs: Deal_Splits_Share_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Share_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_share_preview(inputs)
	return cs_deal_splits_share_preview(inputs)
});